// src/redux/reducers/globalConfigsReducer.js
// Redux reducer for managing global configs state

import {
  FETCH_GLOBAL_CONFIG_START,
  FETCH_GLOBAL_CONFIG_SUCCESS,
  FETCH_GLOBAL_CONFIG_FAILURE,
  SAVE_GLOBAL_CONFIG_START,
  SAVE_GLOBAL_CONFIG_SUCCESS,
  SAVE_GLOBAL_CONFIG_FAILURE,
  FETCH_ALL_GLOBAL_CONFIGS_START,
  FETCH_ALL_GLOBAL_CONFIGS_SUCCESS,
  FETCH_ALL_GLOBAL_CONFIGS_FAILURE
} from '../actions/globalConfigActions';

/**
 * Global configs state structure:
 * {
 *   configs: {
 *     modelFormConfig: { fields: [...] },
 *     ...future global configs
 *   },
 *   allConfigs: [
 *     { config_key: 'modelFormConfig', description: '...', ... }
 *   ],
 *   loading: boolean,
 *   saving: boolean,
 *   error: string | null
 * }
 */

const initialState = {
  configs: {},        // Keyed by config_key
  allConfigs: [],     // List of all available configs (metadata)
  loading: false,
  saving: false,
  error: null
};

export default function globalConfigsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GLOBAL_CONFIG_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_GLOBAL_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        configs: {
          ...state.configs,
          [action.payload.configKey]: action.payload.configData
        }
      };

    case FETCH_GLOBAL_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    case SAVE_GLOBAL_CONFIG_START:
      return {
        ...state,
        saving: true,
        error: null
      };

    case SAVE_GLOBAL_CONFIG_SUCCESS:
      return {
        ...state,
        saving: false,
        configs: {
          ...state.configs,
          [action.payload.configKey]: action.payload.configData
        }
      };

    case SAVE_GLOBAL_CONFIG_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload.error
      };

    case FETCH_ALL_GLOBAL_CONFIGS_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ALL_GLOBAL_CONFIGS_SUCCESS:
      return {
        ...state,
        loading: false,
        allConfigs: action.payload
      };

    case FETCH_ALL_GLOBAL_CONFIGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
